import React from 'react';
import { useTranslation } from 'react-i18next';
import Hero from '../components/Hero';
import HubExplorer from '../components/HubExplorer';
import Outcomes from '../components/Outcomes';
import Features from '../components/Features';
import Solutions from '../components/Solutions';
import HomeContentExplore from '../components/HomeContentExplore';
import About from '../components/About';
import Partners from '../components/Partners';
import Testimonials from '../components/Testimonials';
import Personalization from '../components/Personalization';
import HomeFaq from '../components/HomeFaq';
import Contact from '../components/Contact';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import { getHomeFaqItems } from '../data/homeFaq';

function HomePage({ locale = 'fr' }) {
  const { t } = useTranslation();
  const canonical = locale === 'en' ? '/en/' : '/';

  return (
    <>
      <SEO
        locale={locale}
        canonical={canonical}
        title={t('seo.homeTitle')}
        description={t('seo.homeDescription')}
      />
      <StructuredData
        page="home"
        locale={locale}
        contentPage={{ path: canonical, title: t('seo.homeTitle') }}
        faqItems={getHomeFaqItems(locale)}
      />
      <main id="main-content">
        <Hero />
        <HubExplorer />
        <Solutions />
        <HomeContentExplore />
        <Outcomes />
        <About />
        <Partners />
        <Testimonials />
        <Features />
        <Personalization />
        <HomeFaq />
        <Contact />
      </main>
    </>
  );
}

export default HomePage;
